import React from "react";
import { Badge } from "@mantine/core";
import { Link } from "react-router-dom";

interface EmployeeCountBadgeProps {
  count: number;
  onClick?: () => void;
  href?: string;
}

const EmployeeCountBadge: React.FC<EmployeeCountBadgeProps> = ({
  count,
  onClick,
  href,
}) => {
  const isClickable = !!href || !!onClick;
  const badge = (
    <Badge
      variant={isClickable ? "filled" : "light"}
      color={count > 0 ? "success" : "light"}
      style={{
        cursor: isClickable ? "pointer" : undefined,
        backgroundColor:
          count > 0 ? "rgba(29, 209, 156, 0.1)" : "rgb(231, 233, 235)",
      }}
      onClick={href ? undefined : onClick}
      title={count === 1 ? "1 employee" : `${count} employees`}
    >
      {count}
    </Badge>
  );
  return href ? (
    <Link to={href} style={{ textDecoration: "none" }}>
      {badge}
    </Link>
  ) : (
    badge
  );
};

export default EmployeeCountBadge;
